const state = {
  document: {
    id: null,
    name: null
  },
  documents: [],
  blueprint: {
    id: null,
    name: null
  },
  blueprints: [],
  dataToPersist: null,
  processPath: null
}

const getters = {
  documentsCreated (state) {
    return state.documents.length ? state.documents : null
  },
  lastDocumentCreated (state) {
    return state.document.id ? state.document : null
  },
  blueprintsCreated (state) {
    return state.blueprints.length ? state.blueprints : null
  },
  lastBlueprintCreated (state) {
    return state.blueprint.id ? state.blueprint : null
  },
  dataToPersist (state) {
    return state.dataToPersist
  },
  processPathToGoBack (state) {
    return state.processPath
  }
}

const mutations = {
  setDocument (state, payload) {
    state.document = payload
    state.documents.push(payload)
  },
  setBlueprint (state, payload) {
    state.blueprint = payload
    state.blueprints.push(payload)
  },
  setDataToPersist (state, payload) {
    state.dataToPersist = payload
  },
  setProcessPath (state, payload) {
    state.processPath = payload
  },
  clearProcessesStore (state) {
    state.document.id = null
    state.document.name = null
    state.documents = []
    state.blueprint.id = null
    state.blueprint.name = null
    state.blueprints = []
    state.dataToPersist = null
    state.processPath = null
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
